import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ActiveLanguages } from "../../../utility/interfaces/patientMasterDataInterface";

interface MasterDataState {
  activeLanguages: ActiveLanguages[];
}

const initialState: MasterDataState = {
  activeLanguages: [],
};

const patientMasterDataSlice = createSlice({
  name: "patientMasterData",
  initialState,
  reducers: {
    setActiveLanguages(state, action: PayloadAction<ActiveLanguages[]>) {
      state.activeLanguages = action.payload;
    },
  },
});

export const patientMasterDataActions = patientMasterDataSlice.actions;

export default patientMasterDataSlice.reducer;
